import { render, staticRenderFns } from "./buttonZalo.vue?vue&type=template&id=4805c9aa&scoped=true"
import script from "./buttonZalo.vue?vue&type=script&lang=js"
export * from "./buttonZalo.vue?vue&type=script&lang=js"
import style0 from "./buttonZalo.vue?vue&type=style&index=0&id=4805c9aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805c9aa",
  null
  
)

export default component.exports